<template lang="pug">
  #list-deliveries
    div(style="display: flex; justify-content: flex-end; gap: 1rem")
      b-button.float-right(v-if="user.role === 'admin' || user.role === 'store'" @click="showMassiveCancelPackageForm" variant="outline-danger") Cancelar seleccionados
      b-button.float-right(v-if="user.role === 'admin' || user.role === 'viewer'" v-model="allPackagesReceived" :disabled="allPackagesReceived" @click="manualRecepction") Recepción Manual
    b-form-checkbox(
      v-model="allSelected"
      style="padding-left: 2.25rem; width: fit-content; font-weight: bold;"
      :indeterminate="indeterminate"
      @change="toggleAll"

    ) {{ allSelected ? 'Deseleccionar todos' : 'Seleccionar todos' }}
    div(ref="tableEl" style="overflow-x: auto; width: 100%;")
      b-table(:items="allPackages" :fields="packagesFields" v-if="packages")
        template(v-slot:cell(selected)="{ item }")
          b-form-checkbox(v-model="item.selected" @change="handleSelect(item)")
        template(#cell(pickedUpByDriver)="{item, index}")
          .scan-cell
            b-form-checkbox(v-model="item.pickedUpByDriver" @change='handlePickup(item, index)' :disabled="user.role!=='admin'")
            span.scan-info.material-icons-outlined(v-if="item.pickedUpByDriverUser" :id="'tooltip-pickup-' + item.id" tabindex="0" role="button" aria-label="Ver detalle de escaneo") info
          b-tooltip(v-if="item.pickedUpByDriverUser" :target="'tooltip-pickup-' + item.id" :triggers="scanTooltipTriggers")
            |  {{ item.pickedUpByDriverUser && item.pickedUpByDriverUser.name }} {{ item.pickedUpByDriverUser && item.pickedUpByDriverUser.lastName }}
            br
            | {{ item.pickedUpByDriverAt }}
        template(#cell(receivedInWarehouse)="{item, index}")
          .scan-cell
            b-form-checkbox(v-if="user.role === 'admin' || user.role === 'viewer'" v-model="item.receivedInWarehouse" @change='handleChange(item, index)')
            template(v-else)
              .material-icons(v-if="item.receivedInWarehouse" style="color: green") check_circle
              .material-icons(v-else style="color: red") cancel
            span.scan-info.material-icons-outlined(v-if="item.receivedInWarehouseByUser" :id="'tooltip-received-in-warehouse-' + item.id" tabindex="0" role="button" aria-label="Ver detalle de escaneo") info
          b-tooltip(v-if="item.receivedInWarehouseByUser" :target="'tooltip-received-in-warehouse-' + item.id" :triggers="scanTooltipTriggers")
            div(v-if="user.role === 'admin' || user.role === 'viewer'")
              span {{ item.receivedInWarehouseByUser && item.receivedInWarehouseByUser.name }} {{ item.receivedInWarehouseByUser && item.receivedInWarehouseByUser.lastName }}
              br
            | {{ item.receivedInWarehouseAt }}
        template(#cell(inTransit)="{item, index}")
          .scan-cell
            b-form-checkbox(v-model="item.inTransit" @change='handleInTransit(item, index)' :disabled="user.role!=='admin'")
            span.scan-info.material-icons-outlined(v-if="item.inTransitByUser" :id="'tooltip-in-transit-' + item.id" tabindex="0" role="button" aria-label="Ver detalle de escaneo") info
          b-tooltip(v-if="item.inTransitByUser" :target="'tooltip-in-transit-' + item.id" :triggers="scanTooltipTriggers")
            | {{ item.inTransitByUser && item.inTransitByUser.name }} {{ item.inTransitByUser && item.inTransitByUser.lastName }}
            br
            | Escaneado: {{item.inTransitScanMode}}
            br
            | {{ item.inTransitAt }}
        template(#cell(exchangeOrReturn)="{item, index}")
          .scan-cell
            b-form-checkbox(v-model="item.exchangeOrReturn" @change='handleExchange(item, index)' :disabled="!(user.role==='admin' || user.role==='viewer')")
            span.scan-info.material-icons-outlined(v-if="item.exchangeOrReturnByUser" :id="'tooltip-exchange-or-return-' + item.id" tabindex="0" role="button" aria-label="Ver detalle de escaneo") info
          b-tooltip(v-if="item.exchangeOrReturnByUser" :target="'tooltip-exchange-or-return-' + item.id" :triggers="scanTooltipTriggers")
            | {{ item.exchangeOrReturnByUser && item.exchangeOrReturnByUser.name }} {{ item.exchangeOrReturnByUser && item.exchangeOrReturnByUser.lastName }}
            br
            | {{ item.exchangeOrReturnAt }}
        template(#cell(isAdditional)="{item}")
          div {{ item.isAdditional ? 'Si' : 'No' }}
        template(#cell(modified)="{item}")
          .material-icons(
            v-if="item.editedAt"
            style="color: var(--info); cursor: help;"
            :title="'Modificado por ' + (item.editedByUser ? item.editedByUser.name + ' ' + item.editedByUser.lastName + ' (' + item.editedByUser.role + ')' : 'Sistema') + ' el ' + item.editedAt"
          ) edit_note
          span(v-else) —
        template(#cell(retirementDate)="{item}")
          div(style="text-wrap: nowrap") {{ item.retirementDate }}
        template(#cell(createdAt)="{item}")
          div(style="text-wrap: nowrap") {{ item.createdAt }}
        template(#cell(createdAtTime)="{item}")
          div(style="text-wrap: nowrap") {{ item.createdAtTime }}
        template(#cell(code)="{item}")
          div(style="text-wrap: nowrap") {{ item.code }}
        template(#cell(actions)="{item}")
          div(v-if="!item.isCanceled")
            div(:id="'tooltip-label-print-' + item.id")
              b-btn.mb-2(@click="printPackage(item)" block) {{ item.labelPrintedAt ? 'Etiqueta impresa' : 'Imprimir' }}
            b-tooltip(v-if="item.labelPrintedByUser" :target="'tooltip-label-print-' + item.id" triggers="hover")
              div(v-if="user.role !== 'store'")
                span {{ item.labelPrintedByUser && item.labelPrintedByUser.name }} {{ item.labelPrintedByUser && item.labelPrintedByUser.lastName }}
                br
              | {{ item.labelPrintedAt }}
            div.mb-2(v-if="user.role === 'admin'")
              AppButton(
                variant="primary"
                outline
                block
                title="Ver historial de modificaciones del paquete"
                @click="openPackageHistory(item)"
              ) Historial
            div.mb-2(v-if="user.role === 'admin' || user.role === 'store'")
              AppTooltip.app-tooltip--fill(
                position="top"
                :content="canEditPackages ? 'Editar paquete' : (editWindowReason || 'Fuera del horario de carga permitido para editar.')"
              )
                AppButton(
                  variant="primary"
                  outline
                  block
                  :disabled="!canEditPackages"
                  @click="openEditPackage(item)"
                ) Editar
            b-btn(v-if="user.role !== 'viewer'" @click="cancelPackage(item.realId, item.code)" variant="outline-danger" block) Cancelar
          div(v-else-if="user.role === 'admin'")
            div.mb-2
              AppButton(
                variant="primary"
                outline
                block
                title="Ver historial de modificaciones del paquete"
                @click="openPackageHistory(item)"
              ) Historial
            b-btn(@click="uncancelPackage(item)" variant="outline-success" block) Des-cancelar
          div(v-if="user.role === 'admin' && $debug.enabled").mt-2
            AppButton(
              variant="danger"
              outline
              block
              title="Editar campos del paquete (solo debug)"
              @click="openDebugPackage(item)"
            ) Debug
    .d-flex.justify-content-between
      div()
        p(v-if="canViewPrices") Costo de Retiro: ${{ retirementPrice.toLocaleString('es-CL') }}
        p(v-if="volumeDiscount > 0 && canViewPrices") Descuento por volumen: ${{ volumeDiscount.toLocaleString('es-CL') }}
      b-btn(@click="printSelected" :disabled="!packagesToPrint.length") Imprimir etiquetas seleccionadas
        b-badge.ml-2(style="font-size: 0.9rem;" variant="info") {{ !packagesToPrint.length ? '' : packagesToPrint.length }}
    PrintAllPackagesLabel(ref="allPackagesLabelTemplate")
    CancelPackageForm(ref="cancelPackageForm" @done="$emit('update')")
    MassiveCancelPackageForm(ref="massiveCancelPackageForm" @done="$emit('update')")
    EditPackageForm(ref="editPackageForm" :store-data="storeData" @done="$emit('update')")
    PackageHistoryModal(ref="packageHistoryModal" :package-item="historyPackageItem")
    DebugPackageForm(ref="debugPackageForm" @done="$emit('update')")
</template>
<script>
import { Printd } from 'printd'
import PrintAllPackagesLabel from '../withdrawal/printPackages/PrintAllPackagesLabel.vue'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment-timezone'
import CancelPackageForm from './CancelPackageForm.vue'
import MassiveCancelPackageForm from './MassiveCancelPackageForm.vue'
import EditPackageForm from './EditPackageForm.vue'
import PackageHistoryModal from './PackageHistoryModal.vue'
import DebugPackageForm from './DebugPackageForm.vue'
import AppButton from '@/components/UI/AppButton.vue'
import AppTooltip from '@/components/UI/AppTooltip.vue'
import { canViewPrices } from '@/constants/userRoles'

export default {
  name: 'ListDeliveries',
  components: {
    PrintAllPackagesLabel,
    MassiveCancelPackageForm,
    CancelPackageForm,
    EditPackageForm,
    PackageHistoryModal,
    DebugPackageForm,
    AppButton,
    AppTooltip
  },
  props: {
    retirementPrice: { type: Number },
    volumeDiscount: { type: Number },
    packages: {
      type: Array,
      required: true
    },
    storeName: {
      type: String,
      required: true
    },
    storeData: {
      type: Object,
      required: false
    },
    withdrawal: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      allPackages: [],
      allPackagesReceived: false,
      packagesToPrint: [],
      allSelected: false,
      indeterminate: false,
      canEditPackages: false,
      editWindowReason: '',
      historyPackageItem: null,
      // En pantallas táctiles no hay hover: el detalle se abre al tocar el ícono info y se cierra al tocar fuera
      scanTooltipTriggers: window.matchMedia('(hover: none)').matches ? 'click blur' : 'hover focus'
    }
  },
  created() {
    this.handleSelectedPackages()
    this.checkPackagesToReceive()
    this.checkCanEdit()
  },
  methods: {
    ...mapActions(['checkWithdrawalHour']),
    async checkCanEdit() {
      this.canEditPackages = false
      this.editWindowReason = ''
      if (this.user.role === 'admin') {
        this.canEditPackages = true
        return
      }
      if (this.user.role !== 'store') {
        return
      }
      if (!this.withdrawal || !this.storeData) {
        return
      }
      const retirementDate = this.withdrawal.retirementDate
      const storeId = this.user.storeId
      if (!retirementDate || !storeId) {
        return
      }
      const res = await this.checkWithdrawalHour({ date: retirementDate, storeId })
      if (res && res.canSchedule) {
        this.canEditPackages = true
      } else {
        this.editWindowReason = (res && res.reason) || 'Fuera del horario de carga permitido para editar.'
      }
    },
    openEditPackage(item) {
      const rawPackage = this.packages.find(p => p.id === item.realId) || item
      this.$refs.editPackageForm.show({ ...rawPackage })
    },
    openPackageHistory(item) {
      const rawPackage = this.packages.find(p => p.id === item.realId) || item
      this.$refs.packageHistoryModal.show({ ...rawPackage })
    },
    openDebugPackage(item) {
      const rawPackage = this.packages.find(p => p.id === item.realId) || item
      this.$refs.debugPackageForm.show({ ...rawPackage })
    },
    handleKeydown(e) {
      if (e.key === 'ArrowLeft') {
        this.$refs.tableEl.scrollBy(-100, 0)
      } else if (e.key === 'ArrowRight') {
        this.$refs.tableEl.scrollBy(100, 0)
      }
    },
    handleSelectedPackages() {
      const allPackages = [...this.packagesItems].sort((a, b) => a.id - b.id)
      this.allPackages = allPackages
      const selected = this.packagesItems.filter((p) => p.selected)
      if (selected) {
        this.packagesToPrint = selected
        return selected
      } else {
        return selected
      }
    },
    handleSelect(item) {
      if (item.selected) {
        this.packagesToPrint.push(item)
      } else {
        this.allSelected = false
        this.indeterminate = true
        this.packagesToPrint = this.packagesToPrint.filter((p) => p.id !== item.id)
      }
    },
    toggleAll(checked) {
      if (checked) {
        this.allPackages = this.allPackages.map((p) => { return { ...p, selected: true } })
        this.packagesToPrint = this.allPackages
      } else {
        this.allPackages = this.allPackages.map((p) => { return { ...p, selected: false } })
        this.packagesToPrint = []
      }
      this.checkPackagesToReceive()
    },
    print() {
      console.log('print')
      const d = new Printd()
      d.print(document.getElementById('list-deliveries'), [])
    },
    async printPackage(item) {
      const ok = await this.$store.dispatch('registerLabelPrint', { ids: [item.realId] })
      if (ok && ok.printedAt) {
        const pkg = this.allPackages.find(p => p.realId === item.realId)
        if (pkg) {
          pkg.labelPrintedAt = moment(ok.printedAt).format('DD-MM-YYYY HH:mm A')
          pkg.labelPrintedByUser = ok.printedByUser
        }
      }
      this.$refs.allPackagesLabelTemplate.print([item])
    },
    async printSelected() {
      const ids = this.packagesToPrint.map(p => p.realId)
      const ok = await this.$store.dispatch('registerLabelPrint', { ids })
      if (ok && ok.printedAt) {
        this.packagesToPrint.forEach(pkg => {
          pkg.labelPrintedAt = moment(ok.printedAt).format('DD-MM-YYYY HH:mm A')
          pkg.labelPrintedByUser = ok.printedByUser
        })
      }
      this.$refs.allPackagesLabelTemplate.print(this.packagesToPrint)
    },
    async cancelPackage(id, code) {
      this.$refs.cancelPackageForm.show(id, code)
    },
    async uncancelPackage(item) {
      const ok = await this.$bvModal.msgBoxConfirm(
        `¿Des-cancelar el paquete ${item.code}? El envío volverá a En Tránsito y se borrarán sus comentarios y datos de entrega.`,
        {
          title: 'Des-cancelar paquete',
          okVariant: 'outline-success',
          cancelVariant: 'outline-primary',
          okTitle: 'Des-cancelar',
          cancelTitle: 'Volver'
        }
      )
      if (!ok) return
      try {
        await this.$store.dispatch('uncancelPackage', { id: item.realId })
        this.$root.$bvToast.toast('Paquete reactivado', {
          title: 'Éxito',
          variant: 'success',
          solid: true
        })
        this.$emit('update')
      } catch (error) {
        console.error(error)
        this.$root.$bvToast.toast(error.response?.data?.error || 'No se pudo des-cancelar el paquete', {
          title: 'Error',
          variant: 'danger',
          solid: true
        })
      }
    },
    async manualRecepction() {
      const packages = this.allPackages
        .map((p, index) => ({ ...p, index }))
        .filter(p => p.receivedInWarehouse === false)
      await packages.map(async p => {
        const ok = await this.updateReceptionPackage(p.realId, { receivedInWarehouse: true }, p.index)

        if (ok) {
          p.receivedInWarehouse = true
          this.allPackages[p.index].receivedInWarehouse = true
        } else {
          console.log(ok)
        }
      })
      this.allPackagesReceived = true
    },
    async handleChange(myPackage, index) {
      const packageToReceive = this.allPackages.filter(p => p.receivedInWarehouse === false)
      if (packageToReceive.length) {
        this.allPackagesReceived = false
      }
      const id = myPackage.realId
      // const data = myPackage.receptionStatus ? { receptionStatus: 'received' } : { receptionStatus: 'not_received' }
      const data = { receivedInWarehouse: myPackage.receivedInWarehouse }
      await this.updateReceptionPackage(id, data, index)
      this.checkPackagesToReceive()
    },
    async updateReceptionPackage(id, data, index) {
      console.log('actualizando paquete....', id)
      try {
        const ok = await this.$store.dispatch('updateReceptionPackage', { id, data })
        // console.log(ok)

        if (ok.receivedInWarehouseAt) {
          // this.allPackages[index].receivedInWarehouse = true
          this.allPackages[index].receivedInWarehouseAt = moment(ok.receivedInWarehouseAt).format('DD-MM-YYYY HH:mm A')
          this.allPackages[index].receivedInWarehouseByUser = {
            name: ok.receivedInWarehouseByUser.name,
            lastName: ok.receivedInWarehouseByUser.lastName,
            email: ok.receivedInWarehouseByUser.email,
            id: ok.receivedInWarehouseByUser.id
          }
          return true
        }
      } catch (error) {
        console.error(error)
      }
    },
    checkPackagesToReceive() {
      const packagesToReceive = this.allPackages.filter(p => p.receivedInWarehouse === false)
      this.allPackagesReceived = !packagesToReceive.length
    },
    async handlePickup(myPackage, index) {
      const id = myPackage.realId
      const data = { pickedUpByDriver: myPackage.pickedUpByDriver }
      console.log('actualizando paquete....', id, data)
      try {
        const ok = await this.$store.dispatch('updatePickupPackage', { id, data })
        // console.log(ok)
        if (ok.pickedUpByDriverAt) {
          this.allPackages[index].pickedUpByDriverAt = moment(ok.pickedUpByDriverAt).format('DD-MM-YYYY HH:mm A')
          this.allPackages[index].pickedUpByDriverUser = {
            name: ok.pickedUpByDriverUser.name,
            lastName: ok.pickedUpByDriverUser.lastName,
            email: ok.pickedUpByDriverUser.email,
            id: ok.pickedUpByDriverUser.id
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    showMassiveCancelPackageForm() {
      if (!this.packagesToPrint.length) {
        this.$root.$bvToast.toast('Debe seleccionar al menos un paquete', {
          title: 'Error',
          variant: 'danger'
        })
        return
      }
      this.$refs.massiveCancelPackageForm.show(this.packagesToPrint.map(p => p.realId))
    },
    async handleInTransit(myPackage, index) {
      const id = myPackage.realId
      const data = { inTransit: myPackage.inTransit }
      console.log('actualizando paquete....', id, data)
      try {
        const ok = await this.$store.dispatch('updateInTransitPackage', { id, data })
        // console.log(ok)

        if (ok.inTransitAt) {
          this.allPackages[index].inTransitAt = moment(ok.inTransitAt).format('DD-MM-YYYY HH:mm A')
          this.allPackages[index].inTransitByUser = {
            name: ok.inTransitByUser.name,
            lastName: ok.inTransitByUser.lastName,
            email: ok.inTransitByUser.email,
            id: ok.inTransitByUser.id
          }
          this.allPackages[index].inTransitScanMode = 'manual'
        }
      } catch (error) {
        console.error(error)
      }
    },
    async handleExchange(myPackage, index) {
      const id = myPackage.realId
      const data = { exchangeOrReturn: myPackage.exchangeOrReturn }
      console.log('actualizando paquete....', id, data)
      try {
        const ok = await this.$store.dispatch('updateExchangeOrReturnPackage', { id, data })
        // console.log(ok)
        if (ok.exchangeOrReturnAt) {
          this.allPackages[index].exchangeOrReturnAt = moment(ok.exchangeOrReturnAt).format('DD-MM-YYYY HH:mm A')
          this.allPackages[index].exchangeOrReturnByUser = {
            name: ok.exchangeOrReturnByUser.name,
            lastName: ok.exchangeOrReturnByUser.lastName,
            email: ok.exchangeOrReturnByUser.email,
            id: ok.exchangeOrReturnByUser.id
          }
        }
      } catch (error) {
        console.error(error)
      }
    }
  },
  computed: {
    ...mapGetters(['user']),
    canViewPrices() {
      return canViewPrices(this.user.role)
    },
    packagesFields() {
      let packagesFields = [
        { key: 'selected', label: 'Seleccionar' },
        { key: 'storeInternalCode', label: 'Código de tienda' },
        { key: 'createdAt', label: 'Fecha de creación' },
        { key: 'createdAtTime', label: 'Hora de creación' },
        { key: 'retirementDate', label: 'Fecha de programación' },
        { key: 'code', label: 'Código' },
        { key: 'internalComment', label: 'Comentario Interno' },
        { key: 'storeName', label: 'Tienda' },
        { key: 'customerName', label: 'Nombre del destinatario' },
        { key: 'customerPhone', label: 'Teléfono de destinatario' },
        { key: 'customerAddress', label: 'Dirección de destino' },
        { key: 'commune', label: 'Comuna de destino' },
        { key: 'observations', label: 'Observaciones' },
        { key: 'customerEmail', label: 'Correo' },
        { key: 'tags', label: 'Tags' },
        { key: 'size', label: 'Tamaño del paquete' },
        { key: 'bundleQuantity', label: 'Cantidad de bultos' },
        { key: 'sourceOrderNumber', label: 'ID Shopify' },
        { key: 'labelCode', label: 'Nº de envío (FLEX)' },
        { key: 'externalId', label: 'ID Externo' },
        { key: 'shippingCost', label: 'Costo de envío' },
        { key: 'pickedUpByDriver', label: 'Retirado por conductor' },
        { key: 'receivedInWarehouse', label: 'Recepcionado en Bodega' },
        { key: 'inTransit', label: 'En Tránsito' },
        { key: 'exchangeOrReturn', label: 'Cambio o devolución' },
        { key: 'modified', label: 'Modificado' },
        { key: 'actions', label: 'Acciones', thStyle: { minWidth: '160px' } }
      ]

      if (!(this.user.role === 'admin' || this.user.role === 'viewer')) {
        packagesFields = packagesFields
          .filter(f =>
            f.key !== 'storeName' &
            f.key !== 'storeInternalCode' &
            f.key !== 'internalComment' &
            f.key !== 'pickedUpByDriver' &
            f.key !== 'inTransit' &
            f.key !== 'exchangeOrReturn' &
            f.key !== 'isAdditional'
          )
      }

      if (this.user.role === 'viewer') {
        packagesFields = packagesFields.filter(f => f.key !== 'isAdditional')
      }

      if (!this.canViewPrices) {
        packagesFields = packagesFields.filter(f => f.key !== 'shippingCost')
      }

      return packagesFields
    },
    packagesItems() {
      const sizeDisplay = { small: 'PEQUEÑO', medium: 'MEDIANO' }
      return this.packages.map(p => {
        return {
          ...p,
          isCanceled: p.isCanceled,
          _rowVariant: p.isCanceled ? 'danger' : '',
          realId: p.id,
          id: p.id.toString().padStart(3, 0),
          customerName: p.customerName,
          customerPhone: p.customerPhone,
          commune: p.commune?.name || 'No asignada',
          customerEmail: p.customerEmail,
          size: sizeDisplay[p.size] || p.size || '',
          shippingCost: `$${p.shippingCost.toLocaleString('es-CL')}`,
          observations: p.observations,
          storeName: this.storeName,
          storeInternalCode: this.storeData?.internalCode?.toUpperCase() || '',
          retirementDate: this.withdrawal?.retirementDate ? moment(this.withdrawal.retirementDate).format('DD-MM-YYYY') : '',
          createdAt: p.createdAt ? moment(p.createdAt).format('DD-MM-YYYY') : null,
          createdAtTime: p.createdAt ? moment(p.createdAt).format('HH:mm') : null,
          internalComment: '',
          customerFullAddress: p.customerAddress,
          receptionStatus: p.receptionStatus === 'received' || false,
          receivedInWarehouse: p.receivedInWarehouse,
          receivedInWarehouseAt: p.receivedInWarehouseAt ? moment(p.receivedInWarehouseAt).format('DD-MM-YYYY HH:mm') : null,
          receivedInWarehouseByUser: p.receivedInWarehouseByUser,
          isAdditional: p.isAdditional,
          code: p.code,
          qrCode: p.qrCode,
          selected: p.selected !== undefined ? p.selected : false,
          logoUrl: this.storeData.logoUrl || '',
          customizableFieldOne: this.storeData.customizableFieldOne || null,
          customizableFieldTwo: this.storeData.customizableFieldTwo || null,
          tags: p.tagsName || '',
          customerAddress: p.customerAddress,
          inTransit: p.inTransit,
          inTransitAt: p.inTransitAt ? moment(p.inTransitAt).format('DD-MM-YYYY HH:mm') : null,
          inTransitByUser: p.inTransitByUser,
          exchangeOrReturn: p.exchangeOrReturn,
          exchangeOrReturnAt: p.exchangeOrReturnAt ? moment(p.exchangeOrReturnAt).format('DD-MM-YYYY HH:mm') : null,
          exchangeOrReturnByUser: p.exchangeOrReturnByUser,
          pickedUpByDriver: p.pickedUpByDriver,
          pickedUpByDriverAt: p.pickedUpByDriverAt ? moment(p.pickedUpByDriverAt).format('DD-MM-YYYY HH:mm') : null,
          pickedUpByDriverUser: p.pickedUpByDriverUser,
          withdrawalId: p.withdrawalId,
          bundleQuantity: p.bundleQuantity,
          inTransitScanMode: p.inTransitScanMode,
          externalId: p.externalId,
          sourceOrderNumber: p.sourceOrderNumber,
          labelPrintedAt: p.labelPrintedAt ? moment(p.labelPrintedAt).format('DD-MM-YYYY HH:mm A') : null,
          labelPrintedByUser: p.labelPrintedByUser,
          editedAt: p.editedAt ? moment.tz(p.editedAt, 'America/Santiago').format('DD-MM-YYYY HH:mm A') : null,
          editedByUser: p.editedByUser || null
        }
      })
    }
  },
  watch: {
    withdrawal() {
      this.checkCanEdit()
    },
    packagesItems: {
      handler(value) {
        const packagesToReceive = this.allPackages.filter(p => !p.receivedInWarehouse)
        this.allPackagesReceived = !packagesToReceive.length
      },
      deep: true
    },
    packagesToPrint(newValue, oldValue) {
      if (newValue.length === 0) {
        this.indeterminate = false
        this.allSelected = false
      } else if (newValue.length === this.packagesItems.length) {
        this.indeterminate = false
        this.allSelected = true
      } else {
        this.indeterminate = true
        this.allSelected = false
      }
    }
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeydown)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeydown)
  }
}
</script>

<style lang="scss" scoped>
.scan-cell {
  display: flex;
  align-items: center;
}

.scan-info {
  font-size: 18px;
  color: var(--info);
  cursor: pointer;
  // Área táctil más grande que el ícono
  padding: 6px;
  margin: -6px 0;
  user-select: none;
}

.app-tooltip.app-tooltip--fill {
  display: block;
  width: 100%;

  ::v-deep .app-tooltip__trigger {
    display: flex;
    width: 100%;
  }

  ::v-deep .app-btn--block {
    flex: 1 0 100%;
    width: 100%;
  }
}
</style>
